<template>
  <div class="record-item">
    <div class="item">
      <div class="date">
        <span>{{data.created_at | fomartTime('yyyy.MM.dd hh:mm:ss')}}</span>
        <span class="date_right">{{data.daily.date | fomartTime('MM.dd')}}</span>
      </div>
      <p class="is_repair"
         v-if="data.is_repair">补卡</p>
      <div class="detail_info">
        <div @click="studyMore(data)">
          <p class="info_title btn">
            <span>再次</span>
            <span>学习</span>
          </p>
        </div>
        <div>
          <span class="info_title">所用时长</span>
          <span>{{$pub.formatSeconds(data.question_time)}}</span>
        </div>
        <div>
          <span class="info_title">正确率</span>
          <span>{{(data.right_count/data.question_count*100)}}%</span>
        </div>
        <div>
          <span class="info_title">得分</span>
          <span>{{data.point}}″</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
        };
      }
    }
  },
  data () {
    return {
    };
  },
  methods: {
    studyMore (data) {
      this.$router.push({ name: 'ExerciseQueston', query: { type: 'CheckIn', id: data.daily_id } })
    }
  }
};
</script>

<style lang="scss" scoped>
.record-item {
  font-family: PingFang SC;
  color: #333;
  font-size: 24px;
  .item {
    height: 292px;
    box-shadow: 0px 0px 10px 0px rgba(56, 56, 56, 0.1);
    border-radius: 10px;
  }
  .date {
    font-size: 28px;
    color: #666;
    padding: 40px 0 40px 28px;
    .date_right {
      height: 42px;
      line-height: 42px;
      text-align: center;
      color: $theme_color;
      border: 1px solid $theme_color;
      float: right;
      margin-top: -10px;
      margin-right: 30px;
      padding: 0 14px;
      border-radius: 4px;
    }
  }
  .is_repair {
    text-align: right;
    padding: 6px 30px 10px 30px;
    color: $theme_color;
  }
  .detail_info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    div {
      text-align: center;
      span {
        display: block;
        color: #222222;
        font-size: 32px;
        margin-top: 35px;
        font-weight: 600;
      }
      img {
        width: 120px;
        height: 120px;
      }
      .info_title {
        color: #999999;
        font-size: 24px;
        margin-top: 0px;
      }
      .btn {
        padding-top: 1px;
        span {
          font-size: 24px;
          color: #ffffff;
          margin: 0;
          line-height: 28px;
        }
        span:nth-child(1) {
          display: block;
          margin-top: 30px;
        }
        display: block;
        width: 120px;
        height: 120px;
        text-align: center;
        color: #fff;
        background: linear-gradient(
          0deg,
          rgba(59, 144, 255, 1),
          rgba(131, 185, 255, 1)
        );
        box-shadow: 1px 3px 4px 0px rgba(59, 144, 255, 0.31);
        border-radius: 50%;
      }
      .nickname {
        margin-top: 14px;
        font-size: 30px;
        color: #222222;
      }
    }
  }
}
</style>
